import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
import {
  add_feed_comment,
  edit_feed_comment,
} from "src/DAL/Community/Comments";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import EmojiPicker from "src/components/GeneralComponents/EmojiPicker";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { s3baseUrl } from "src/config/config";
import MentionEditor from "./components/MentionEditor";

export default function AddComment({
  post_id,
  feedsData,
  formAction,
  setFormAction,
  setShowAddComment,
  list_type,
  feed,
  event_id,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [state, setState] = useState("");
  const [image, setImage] = useState("");
  const [previews, setPreviews] = useState("");
  const [oldImage, setOldImage] = useState("");
  const [commentId, setCommentId] = useState("");
  const [updateValue, setUpdateValue] = useState({});
  const [mentionedUsers, setMentionedUsers] = useState([]);
  const mentionEditorRef = useRef(null);
  const settings = useContentSetting();
  const { socket } = settings;
  const inputRef = useRef(null);

  const handleRemove = () => {
    setPreviews("");
    setOldImage("");
    setImage("");
  };

  const handleUpload = (event) => {
    setImage(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
  };

  //Adding Category
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("feed", post_id);
    formData.append("mentioned_users", JSON.stringify(mentionedUsers));
    formData.append("message", state);
    if (image) {
      formData.append("image", image);
    }

    const result = await add_feed_comment(formData);
    if (result.code === 200) {
      const socketData = {
        action: "add_comment",
        feed_id: post_id,
        token: localStorage.getItem("token"),
        creator_id: result.action_response.creator_id,
        action_by: result.action_response.sender,
        action_response: result.action_response,
      };
      if (list_type == "the_cosmos") {
        socket.emit("delegate_feed_room_action_event", socketData);
      } else {
        socket.emit("feed_room_action_event", socketData);
      }
      handleRemove();
      setState("");
      mentionEditorRef.current?.clearContent();
      setShowEmojiPicker(false);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("message", state);
    formData.append("mentioned_users", JSON.stringify(mentionedUsers));
    if (image) {
      formData.append("image", image);
    } else if (feedsData.image?.thumbnail_2 && !oldImage) {
      formData.append("is_image_deleted", true);
    }
    const result = await edit_feed_comment(formData, commentId);
    if (result.code === 200) {
      const socketData = {
        action: "edit_comment",
        feed_id: post_id,
        comment: commentId,
        token: localStorage.getItem("token"),
        creator_id: result.action_response.creator_id,
        action_by: result.action_response.sender,
        action_response: result.action_response,
      };
      if (list_type == "the_cosmos") {
        socket.emit("delegate_feed_room_action_event", socketData);
      } else {
        socket.emit("feed_room_action_event", socketData);
      }

      setState("");
      mentionEditorRef.current?.clearContent();
      setShowEmojiPicker(false);
      setIsLoading(false);
      setFormAction("ADD");
      setShowAddComment(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleCancelUpdate = (e) => {
    e.preventDefault();
    setState("");
    mentionEditorRef.current?.clearContent();
    setFormAction("ADD");
    setShowAddComment(false);
  };

  useEffect(() => {
    if (formAction === "EDIT") {
      setState(feedsData.message);
      setCommentId(feedsData._id);
      setMentionedUsers(feedsData.mentioned_users);
      if (feedsData.image?.thumbnail_2) {
        setOldImage(feedsData.image?.thumbnail_2);
      }
      setUpdateValue(feedsData);
    }
  }, [formAction]);

  let feed_level = feed.created_for_level_or_type;

  if (
    list_type === "the_source" ||
    list_type === "all_source" ||
    list_type === "scheduled"
  ) {
    feed_level = feed.badge_level_info?._id;
  }

  return (
    <>
      <div className="new-memories add-comment-box">
        <form onSubmit={formAction === "ADD" ? handleSubmit : handleUpdate}>
          <MentionEditor
            ref={mentionEditorRef}
            setInputs={setState}
            setMentionedUsers={setMentionedUsers}
            mentionedUsers={mentionedUsers}
            feedLevels={[feed_level]}
            placeholder={`Write a comment…`}
            list_type={list_type}
            event_id={event_id}
            editorClass="comment-editor mt-2"
            addPosition={{ top: 15, left: 15 }}
            value={state}
            updateValue={updateValue}
          />
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <div className="text-start mt-3 mb-2 picker-empty-div"></div>

              {previews || oldImage ? (
                <span className="preview-comment-image mt-2 ms-2">
                  <span onClick={handleRemove}>x</span>
                  {previews ? (
                    <img src={previews} />
                  ) : (
                    <img src={s3baseUrl + oldImage} />
                  )}
                </span>
              ) : (
                <>
                  <input
                    color="primary"
                    accept="image/*"
                    type="file"
                    id="message-chat-upload-button"
                    style={{ display: "none" }}
                    name=""
                    onChange={handleUpload}
                  />
                  <label>
                    <Tooltip title="Add Image" placement="top">
                      <IconButton
                        onClick={() => {
                          document.getElementById(
                            "message-chat-upload-button"
                          ) &&
                            document
                              .getElementById("message-chat-upload-button")
                              .click();
                        }}
                        className="upload-image-icon-comment mb-2"
                      >
                        <AddPhotoAlternateIcon />
                      </IconButton>
                    </Tooltip>
                  </label>
                </>
              )}
            </div>
            <div className="text-end mt-3">
              {formAction === "ADD" && (
                <button className="comment-submit-button" disabled={isLoading}>
                  {isLoading ? "Saving..." : "Post Comment"}
                </button>
              )}
              {formAction === "EDIT" && (
                <div className="d-flex justify-content-end">
                  <button
                    className="me-2 comment-submit-button"
                    onClick={handleCancelUpdate}
                  >
                    Cancel
                  </button>
                  <button
                    className="comment-submit-button"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Updating..." : "Update"}
                  </button>
                </div>
              )}
            </div>
          </div>
          {showEmojiPicker && (
            <div className="col-12 mt-4 mt-lg-0 ms-auto">
              <EmojiPicker inputRef={inputRef} setInput={setState} />
            </div>
          )}
        </form>
      </div>
    </>
  );
}
